import { notification } from 'antd';
import React from 'react';
import styles from '../styles/notification.scss';
import { generateUUID } from './utils';

notification.config({
  top: 100,
});

const buildActionOptions = (actionButton, defaultKey) => {
  const { onClick, onClose, text } = actionButton;
  const key = defaultKey || generateUUID();

  const handleCloseClick = () => {
    notification.close(key);
    onClick && onClick();
  };

  return {
    key,
    onClose,
    btn: <button type="button" onClick={handleCloseClick}>
      {text}
    </button>,
  };
};

export const show = (message, autoHide = true, key) => {
  notification.open({
    key,
    message,
    className: styles.notification,
    duration: autoHide ? undefined : 0,
  });
};

export const showError = (message) => {
  notification.error({
    message,
    className: styles.notification,
  });
};

export const showHiddenAction = (message, actionButton) => {
  notification.open({
    message,
    className: styles.notification,
    ...buildActionOptions(actionButton),
  });
};

export const showErrorWithAction = (message, actionButton) => {
  notification.error({
    message,
    className: styles.notification,
    duration: 0,
    ...buildActionOptions(actionButton),
  });
};

export const { close } = notification;



// WEBPACK FOOTER //
// ./src/services/notification.js